module.exports = require("@wildboar/x500/src/lib/matching/equality/authAttIdMatch");